import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setSendMessageAbort } from '../../../actions/sendMessage';
import { retrySendMessageById } from '../../../actions/sendMessage/retrySendMessageById';
import {
  clientEventsSelector,
  currentChatOpponentIdSelector,
  currentOpenChatIDSelector,
  currentOpenChatSelector,
} from '../../../selectors';
import { TMessageSchema } from '../../../types/messages';
import { TOpenedChat } from '../../../types/openedChats';
import { trackFileErrorMenuClick } from '../tracking';

export type TMenuItem = {
  title: React.ReactNode;
  handler(): void;
};

export const useMessageErrorMenu = (messageId: string, isOfferMessage: boolean): TMenuItem[] => {
  const dispatch = useDispatch();
  const chatId = useSelector(currentOpenChatIDSelector) || '';
  const clientEvents = useSelector(clientEventsSelector);
  const opponentId = useSelector(currentChatOpponentIdSelector);

  const currentChat = useSelector(currentOpenChatSelector);
  const { pendingFiles } = currentChat || ({} as TOpenedChat);

  const fileType = React.useMemo(() => {
    const blobFiles = pendingFiles?.[messageId]?.blobFiles || [];

    return blobFiles[0]?.type;
  }, [messageId, pendingFiles]);

  return React.useMemo(
    () => [
      {
        title: <UIText2 color="black_100">Отправить снова</UIText2>,
        handler: () => {
          dispatch(retrySendMessageById(chatId as string, messageId));
          trackFileErrorMenuClick({
            action: 'Reload_sopr',
            fileType,
            chatId,
            label: isOfferMessage ? 'Offer' : '',
            opponentId,
          });
        },
      },
      {
        title: <UIText2 color="black_100">Удалить сообщение</UIText2>,
        handler: () => {
          dispatch(setSendMessageAbort({ message: { chatId } as TMessageSchema, messageId }));
          clientEvents.delete(messageId);
          trackFileErrorMenuClick({
            action: 'Delete_sopr',
            fileType,
            chatId,
            label: isOfferMessage ? 'Offer' : '',
            opponentId,
          });
        },
      },
    ],
    [dispatch, chatId, messageId, fileType, isOfferMessage, opponentId, clientEvents],
  );
};
